module.exports = __webpack_public_path__ + "assets/img/4.8fc77707.png";